export const DPIA_EMPTY_VALUE = '—';

export const formatDpiaSidePanelText = (value?: string | null): string => {
  if (!value?.trim()) {
    return DPIA_EMPTY_VALUE;
  }

  return value.trim();
};

export const formatDpiaSidePanelList = (items: string[]): string => {
  const joined = items.filter(Boolean).join(', ');

  return joined || DPIA_EMPTY_VALUE;
};
